import {DictionariesModel} from '@web/core/models/api/core/dictionaries.model'

export const getGrantIds = (dictionaries: DictionariesModel, type: string) => {
  const grantDict = dictionaries['EduGroupStat.Type']
  return Object.keys(grantDict).filter(key => key.includes(type)).map(key => grantDict[key].id)
}
